/*
  BARRA DE COMPRA FIXA — Not That Deep

  Faz tres coisas, e so tres. Nenhuma delas e "adicionar ao carrinho": quem
  faz isso continua sendo o formulario do Dawn, e o botao daqui apenas aponta
  para ele pelo atributo HTML `form=`. Nao existe um segundo caminho de compra
  para sair de sincronia com o primeiro.

  1. ESPELHA o botao real (rotulo e estado desabilitado) e o preco real.
  2. MOSTRA/ESCONDE por IntersectionObserver no botao real: enquanto o botao
     de verdade esta na tela, a barra fica fora. Nunca dois CTAs iguais.
  3. Fica INERT enquanto escondida, para nao virar um tab stop fantasma.

  A parte que exige cuidado: o product-info.js do Dawn RE-RENDERIZA a coluna
  de informacao a cada troca de variante, e o botao real e substituido por um
  no novo. Qualquer observer preso ao no antigo morre em silencio. Por isso
  tudo passa por sincronizar(), que re-consulta os elementos e re-observa.
*/

class NtdComprarFixo extends HTMLElement {
  connectedCallback() {
    this.botao = this.querySelector('[data-ntd-botao]');
    this.rotulo = this.querySelector('[data-ntd-rotulo]');
    this.preco = this.querySelector('[data-ntd-preco]');
    this.rotuloEscolhido = this.rotulo ? this.rotulo.textContent.trim() : '';

    this.info = document.querySelector('product-info');
    if (!this.info || !this.botao) return;

    // O formulario real. E ele que leva ao carrinho; a barra so o dispara.
    const form = this.info.querySelector('form[data-type="add-to-cart-form"]');

    // ATENCAO: `form.id` NAO devolve o id do formulario aqui. Todo formulario
    // de produto do Shopify tem um <input name="id"> com o id da variante, e
    // controles nomeados viram propriedades do proprio <form> — entao
    // `form.id` devolve esse INPUT e sombreia o atributo. Escrever
    // `setAttribute('form', form.id)` grava a string "[object
    // HTMLInputElement]", o botao nao fica associado a formulario nenhum e o
    // clique simplesmente nao faz nada. Sem erro no console, sem aviso.
    // `getAttribute('id')` le o atributo de verdade.
    const formId = form ? form.getAttribute('id') : null;
    if (!formId) return;
    this.botao.setAttribute('form', formId);

    this.aoIntersectar = this.aoIntersectar.bind(this);
    this.sincronizar = this.sincronizar.bind(this);

    // Re-sincroniza sempre que o Dawn troca a variante e re-renderiza a coluna.
    this.mutacoes = new MutationObserver(this.sincronizar);
    this.mutacoes.observe(this.info, { childList: true, subtree: true });

    this.sincronizar();
    document.documentElement.classList.add('ntd-barra-ativa');
  }

  disconnectedCallback() {
    if (this.mutacoes) this.mutacoes.disconnect();
    if (this.olho) this.olho.disconnect();
    document.documentElement.classList.remove('ntd-barra-ativa');
  }

  sincronizar() {
    const real = this.info.querySelector('.product-form__submit');
    if (!real) return;

    // Espelha estado e rotulo. Quando o Dawn escreve "Esgotado" no botao real,
    // a barra tem que dizer a mesma coisa — senao ela promete o que a pagina
    // ja nega.
    const desabilitado = real.hasAttribute('disabled');
    this.botao.disabled = desabilitado;
    if (this.rotulo) {
      const textoReal = (real.textContent || '').trim();
      this.rotulo.textContent = desabilitado && textoReal ? textoReal : this.rotuloEscolhido;
    }

    const precoReal = this.info.querySelector('.price__container .price-item--last, .price__container .price-item--regular');
    if (this.preco && precoReal) this.preco.textContent = precoReal.textContent.trim();

    // O botao real pode ter sido substituido pelo re-render: re-observa.
    if (this.observado !== real) {
      if (this.olho) this.olho.disconnect();
      this.olho = new IntersectionObserver(this.aoIntersectar, { rootMargin: '0px' });
      this.olho.observe(real);
      this.observado = real;
    }
  }

  aoIntersectar(entradas) {
    const visivel = entradas.some((e) => e.isIntersecting);
    this.alternar(!visivel);
  }

  alternar(mostrar) {
    if (this.mostrando === mostrar) return;
    this.mostrando = mostrar;
    this.hidden = !mostrar;
    // `inert` tira a barra escondida da ordem de tabulacao E das leituras de
    // leitor de tela. `hidden` sozinho ja faria isso, mas a barra e animada
    // com transform e precisa continuar pintada durante a saida.
    if (mostrar) this.removeAttribute('inert');
    else this.setAttribute('inert', '');
  }
}

if (!customElements.get('ntd-comprar-fixo')) {
  customElements.define('ntd-comprar-fixo', NtdComprarFixo);
}
